import * as React from "react";

import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "../../utils";

const Progress = ({
  ref,
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "af-relative af-h-4 af-w-full af-overflow-hidden af-rounded-full af-bg-secondary",
      className,
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="af-h-full af-w-full af-flex-1 af-bg-primary af-transition-all"
      style={{ transform: `translateX(-${100 - (value ?? 0)}%)` }}
    />
  </ProgressPrimitive.Root>
);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
